import React from "react";
import "./Showcase.scss";
import { B1, H3 } from "../../ui/Typography";
import {
  AddUser,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Block,
  CalenderIcon,
  CalenderIcon2,
  Clock,
  Close,
  Copy,
  Danger,
  DoubleArrowLeft,
  DoubleArrowRight,
  DownloadIcon,
  Edit,
  EllipsisH,
  Eye,
  Filter,
  FullScreen,
  Info,
  LinkIcon,
  LoadingIcon,
  Location,
  Magnifier,
  Minus,
  Pause,
  Play,
  Playback,
  Rating,
  Save,
  Share,
  Shuffle,
  StashBoard,
  TickRight,
  Trash,
  Trash2,
  WarningIcon,
  UploadIcon,
  Verified,
  Vision,
  GoogleIcon,
  FacebookIcon,
  TwitterIcon,
  Call,
  LoadingSuccess,
} from "../../ui/icons";
import { Table, TableCell, TableRow } from "../../ui";

function ShowcaseIcons() {
  return (
    <>
      <div className="showcase-wrapper">
        <H3>Icons (XL)</H3>
        <div className="showcase-inner">
          <Table className="showcase-table icons-showcase" columns={10}>
            <TableRow>
              <TableCell>
                <DownloadIcon size="xl" />

                <B1>DownloadIcon</B1>
              </TableCell>
              <TableCell>
                <UploadIcon size="xl" />

                <B1>UploadIcon</B1>
              </TableCell>
              <TableCell>
                <CalenderIcon size="xl" />

                <B1>CalenderIcon</B1>
              </TableCell>
              <TableCell>
                <CalenderIcon2 size="xl" />

                <B1>CalenderIcon2</B1>
              </TableCell>
              <TableCell>
                <ArrowDown size="xl" />

                <B1>ArrowDown</B1>
              </TableCell>
              <TableCell>
                <ArrowUp size="xl" />

                <B1>ArrowUp</B1>
              </TableCell>
              <TableCell>
                <ArrowRight size="xl" />

                <B1>ArrowRight</B1>
              </TableCell>
              <TableCell>
                <DoubleArrowRight size="xl" />

                <B1>DoubleArrowRight</B1>
              </TableCell>
              <TableCell>
                <ArrowLeft size="xl" />

                <B1>ArrowLeft</B1>
              </TableCell>
              <TableCell>
                <DoubleArrowLeft size="xl" />

                <B1>DoubleArrowLeft</B1>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TickRight size="xl" />

                <B1>TickRight</B1>
              </TableCell>
              <TableCell>
                <Minus size="xl" />

                <B1>Minus</B1>
              </TableCell>
              <TableCell>
                <Info size="xl" />

                <B1>Info</B1>
              </TableCell>
              <TableCell>
                <Eye size="xl" />

                <B1>Eye</B1>
              </TableCell>
              <TableCell>
                <Verified size="xl" />

                <B1>Verified</B1>
              </TableCell>
              <TableCell>
                <Magnifier size="xl" />

                <B1>Magnifier</B1>
              </TableCell>
              <TableCell>
                <Clock size="xl" />

                <B1>Clock</B1>
              </TableCell>
              <TableCell>
                <Close size="xl" />

                <B1>Close</B1>
              </TableCell>
              <TableCell>
                <StashBoard size="xl" />

                <B1>StashBoard</B1>
              </TableCell>
              <TableCell>
                <Vision size="xl" />

                <B1>Vision</B1>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Block size="xl" />

                <B1>Block</B1>
              </TableCell>
              <TableCell>
                <Filter size="xl" />

                <B1>Filter</B1>
              </TableCell>
              <TableCell>
                <Play size="xl" />

                <B1>Play</B1>
              </TableCell>
              <TableCell>
                <Pause size="xl" />

                <B1>Pause</B1>
              </TableCell>
              <TableCell>
                <EllipsisH size="xl" />

                <B1>EllipsisH</B1>
              </TableCell>
              <TableCell>
                <AddUser size="xl" />

                <B1>AddUser</B1>
              </TableCell>
              <TableCell>
                <Edit size="xl" />

                <B1>Edit</B1>
              </TableCell>
              <TableCell>
                <Share size="xl" />

                <B1>Share</B1>
              </TableCell>
              <TableCell>
                <Save size="xl" />

                <B1>Save</B1>
              </TableCell>
              <TableCell>
                <Trash size="xl" />

                <B1>Trash</B1>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Trash2 size="xl" />
                <B1>Trash2</B1>
              </TableCell>
              <TableCell>
                <WarningIcon size="xl" />

                <B1>WarningIcon</B1>
              </TableCell>
              <TableCell>
                <Danger size="xl" />

                <B1>Danger</B1>
              </TableCell>
              <TableCell>
                <Rating size="xl" />

                <B1>Rating</B1>
              </TableCell>
              <TableCell>
                <Location size="xl" />

                <B1>Location</B1>
              </TableCell>
              <TableCell>
                <LoadingIcon size="xl" />

                <B1>LoadingIcon</B1>
              </TableCell>
              <TableCell>
                <LoadingSuccess size="xl" />

                <B1>LoadingSuccess</B1>
              </TableCell>
              <TableCell>
                <Playback size="xl" />

                <B1>Playback</B1>
              </TableCell>
              <TableCell>
                <LinkIcon size="xl" />

                <B1>LinkIcon</B1>
              </TableCell>
              <TableCell>
                <FullScreen size="xl" />

                <B1>FullScreen</B1>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Copy size="xl" />

                <B1>Copy</B1>
              </TableCell>
              <TableCell>
                <Shuffle size="xl" />

                <B1>Shuffle</B1>
              </TableCell>
              <TableCell>
                <GoogleIcon size="xl" />

                <B1>GoogleIcon</B1>
              </TableCell>
              <TableCell>
                <FacebookIcon size="xl" />

                <B1>FacebookIcon</B1>
              </TableCell>
              <TableCell>
                <TwitterIcon size="xl" />

                <B1>TwitterIcon</B1>
              </TableCell>
              <TableCell>
                <Call size="xl" />

                <B1>Call</B1>
              </TableCell>
            </TableRow>
          </Table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseIcons;
